export const arrMatrix1 = [
{
     name: 'Илон',
     icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
      matrix: [
          { val: 1, icon: 10 },
          { val: 0 },
          { val: 0 },
          { val: 0 },
          { val: 0 },
          { val: 0 },
          { val: 1, icon: 10 },
        ],
    },
  {
      name: 'Клава',
      matched: true,
      active: false,
      icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
      matrix: [
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
      ],
    },
  {
      name: 'Семен',
      matched: true,
      active: false,
      icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
      id: 6,
      matrix: [
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
      ],
    },
    {
      name: 'Егор',
      icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
      matched: true,
      active: false,
      id: 6,
      matrix: [
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
      ],
    },
    {
      name: 'Толя',
      me: true,
      icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
      matrix: [
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        {
          val: 1,
          icon: 'help',
          question: true,
          answer: null,
          activate: false,
        },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
      ],
    },
]

export const arrMatrix2 = [
  {
    name: 'Илон',
    matched: true,
    active: false,
    icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Клава',
    matched: true,
    active: false,
    icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Семен',
    icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    matched: true,
    active: false,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
    ],
  },

  {
    name: 'Толя',
    me: true,
    icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      {
        val: 1,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
    ],
  },
]
export const arrMatrix3 = [
  {
    name: 'Илон',
    icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
    matched: true,
    active: false,
    matrix: [
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Клава',
    matched: true,
    active: false,
    icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Семен',
    icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
    ],
  },

  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    matched: true,
    active: false,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },

  {
    name: 'Толя',
    me: true,
    icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      {
        val: 1,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
    ],
  },
]

// export const arrPopup0 = [
//   { text: 'Задание: Проанализировать таблицу и определить, можно ли рекомендовать неизвестные мелодии Толе.', buttonTitle: 'Начать' },
// ]
export const arrPopup1 = [
  { text: 'Но так как в реальной жизни пользователей очень много, для каждого из профилей похожих будет несколько. Выдели все профили, которые похожи на профиль Толи.', buttonTitle: 'Продолжить' },
]
export const arrPopupChooseUser = [
  { text: 'Теперь, чтобы определить рекомендацию, нужно понять, понравилась ли данная песня большинству из них?', buttonTitle: 'Продолжить' },
]

export const task1 = [
  { text: 'Задание: выдели все профили, которые похожи на профиль Толи.' },
]

export const task2 = [
  { text: 'Задание: пойми, понравилась ли данная песня большинству из них?' },
]
// export const arrPopup2 = [
//   { text: 'Согласен. Мне тоже кажется, чему понравится!!.' },
// ]
// export const arrPopup3 = [
//   { text: 'Согласен. Мне тоже кажется, что рекомендовать эту песню Толе не нужно.' },
// ]
// export const arrPopup4 = [
//   { text: 'пробуй еще' },
// ]
// export const arrPopupChooseUserWrong = [
//   { text: 'Не уверен, что этот этот профиль похож на профиль Толи. Посмотри внимательнее.' },
// ]
